// extracted by mini-css-extract-plugin
export default {"section":"styles_section__qQH5P","text-center":"styles_text-center__2K6X0"};